import { render, staticRenderFns } from "./serviceCreateAppointment.vue?vue&type=template&id=d0f2d2dc&"
import script from "./serviceCreateAppointment.vue?vue&type=script&lang=js&"
export * from "./serviceCreateAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports